import type { PersonConnectionFullResponse } from '@on3/api';
import clsx from 'clsx';
import { On3Avatar } from 'components/Image/On3Avatar';
import { TeamAvatar } from 'components/Image/TeamAvatar';
import { StarRating } from 'components/UI/StarRating/StarRating';
import Link from 'next/link';

import styles from './RemindUs.module.scss';

export const RemindUs = ({
  connection,
  connectedPlayer,
  connectedRating,
  connectedCollegeOrganization,
  connectedDraft,
}: PersonConnectionFullResponse) => {
  return (
    <section className={styles.block}>
      <h2>Reminds Us Of</h2>
      <div className={styles.player}>
        <On3Avatar
          altText={`${connectedPlayer?.fullName ?? ''} Avatar`}
          className={styles.avatar}
          domain={connectedPlayer?.defaultAsset?.domain}
          height={100}
          source={connectedPlayer?.defaultAsset?.source}
          width={100}
        />
        <div className={styles.meta}>
          <Link className={styles.name} href={`/db/${connectedPlayer?.slug}/`}>
            {connectedPlayer?.fullName ?? ''}
          </Link>
          <div className={clsx(styles.details, styles.vitals)}>
            {connectedPlayer?.primaryPosition?.abbr || '-'}
            <span role="separator">/</span>
            {connectedPlayer?.height ?? '-'}
            <span role="separator">/</span>
            <span>{connectedPlayer?.weight ?? '-'}</span>
          </div>
          <StarRating
            grayRating
            hasBorder={false}
            href={`/db/${connectedPlayer?.slug}/industry-comparison/`}
            isBoldRating={false}
            isConsensus
            rating={connectedRating?.consensusRating}
            rounding={2}
            stars={connectedRating?.consensusStars}
          />
          {connectedCollegeOrganization && (
            <div className={styles.orgWrapper}>
              <TeamAvatar
                className={styles.teamAvatar}
                height={25}
                slug={connectedDraft?.collegeOrganization?.slug}
                src={connectedDraft?.collegeOrganization?.assetUrl}
                width={25}
              />
              {connectedPlayer?.classYear && (
                <span className={styles.details}>
                  HS Class of {connectedPlayer.classYear}
                </span>
              )}
            </div>
          )}
          {connectedDraft && (
            <div className={styles.orgWrapper}>
              <TeamAvatar
                className={styles.teamAvatar}
                height={25}
                slug={connectedDraft?.organization?.fullName}
                src={connectedDraft?.organization?.assetUrl}
                width={25}
              />
              <div className={styles.details}>
                {connectedDraft.year}
                <span>Draft: Rnd</span>
                {connectedDraft.round} <span role="separator">/</span>
                <span>Pick</span>
                {connectedDraft.pick}
              </div>
            </div>
          )}
        </div>
      </div>
      <p>{connection?.description ?? 'No description Available'}</p>
    </section>
  );
};
